import { AlertCircle } from "lucide-react";

const AlertSection = ({ alert }: { alert: string }) => {
  const isAlert = alert && alert.toLowerCase() !== "none";

  if (!isAlert) return null;

  return (
    <div className="flex items-center bg-red-500 px-6 py-4 text-white">
      <AlertCircle className="mr-3 size-6" />
      <p className="text-base font-medium">{alert}</p>
    </div>
  );
};

export default AlertSection;
